import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AuthenticationState, AzureAD } from 'react-aad-msal';
import { authProvider } from './AADProvider';
import { useHistory } from 'react-router';
import { getMe } from 'src/helpers/backend_helper';
import { axiosApi } from 'src/helpers/api_helper';
import AuthUI from './AuthUI';





const HendyStaffLogin = () => {
    const {t} = useTranslation();
    const history = useHistory();

    console.log(process.env.REACT_APP_AZURE_CALLBACK_URL);
    console.log(process.env.REACT_APP_AZURE_APPLICATION_ID);

    const goProduct = (accountInfo: any) => {
        sessionStorage.setItem('accessToken', accountInfo.jwtIdToken);
        axiosApi.defaults.headers.common["Authorization"] = "Bearer " + accountInfo.jwtIdToken;
        getMe().then((user: any) => {
            sessionStorage.setItem("authUser", JSON.stringify({
                ...user,
                LOGIN_METHOD: 'ADMIN_LOGIN'
            }))
            history.replace('/products');
        }).catch(console.log);

        return <AuthUI showLogin={false} />;
    }

    return (
        <AzureAD provider={authProvider} forceLogin={true}>
            {
                ({ login, logout, authenticationState, error, accountInfo }: any) => {
                    switch (authenticationState) {
                        case AuthenticationState.Authenticated:
                            return goProduct(accountInfo);
                        case AuthenticationState.Unauthenticated:
                            return ( <AuthUI login={login} showLogin={true} />);
                        case AuthenticationState.InProgress:
                            return (<AuthUI showLogin={false} />);
                    }
                }
            }
        </AzureAD>
    )
}


export default HendyStaffLogin;

const LogoImg = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`
